export const hasValueError = (value: number, waterQualityTypeId: number) => {
  switch (waterQualityTypeId) {
    case 1: {
      // dissolved oxygen
      return value < 0 || value > 20;
    }
    case 2: {
      // turbidity
      return value < 0 || value > 120;
    }
    case 3: {
      // water temperature
      return value < 15 || value > 45;
    }
    case 4: {
      // salinity
      return value < 0 || value > 60;
    }
    case 5: {
      // pH
      return value < 0 || value > 14;
    }
    default: {
      return false;
    }
  }
};
